// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.css
// module id = 675
// module chunks = 14